import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { CarLoadRoutingModule } from '@ruby/modules/car-traffic/submodules/car-load/car-load-routing.module';
import { CarLoadComponent } from '@ruby/modules/car-traffic/submodules/car-load/components/car-load.component';
import { CarLoadContainer } from '@ruby/modules/car-traffic/submodules/car-load/containers/car-load.container';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [CarLoadContainer, CarLoadComponent],
  imports: [
    CommonModule,
    CarLoadRoutingModule,
    NSGridModule.forRoot(GridPreferencesCustomService)
  ],
  exports: [CarLoadContainer]
})
export class CarLoadModule {}
